export const getColorByMatchingScore = (matchingScore: number): string => {
  if (matchingScore < 0.5) {
    return 'red';
  } else if (matchingScore < 0.7) {
    return 'orange';
  } else {
    return 'green';
  }
};
